<template>
	<teleport to="body">
		
		<div id="modal-delete-dataset">

			<div class="rp-overlay h-full"></div>

			<div class="rp-modal" style="width: 470px;">

				<div v-if="layout.dataset" class="modal-content pb-2">
					
					<div class="rp-modal-header">
						<h3 class="rp-modal-title">{{ $t('Delete dataset') }}</h3>
						<button class="rp-btn-dismiss"
							@click="$emit('closeModal')">
							<XIcon class="w-5 h-5" />
						</button>
					</div>

					<div class="relative text-gray-700 dark:text-gray-300 px-5 pt-3">
						<p class="text-sm mb-4 text-gray-600">
							{{ $t('To confirm deletion, please type the dataset ID:') }} <br>
							<b>{{ layout.dataset.id }}</b>
						</p>
						<input type="text" v-model="layout.deleteInput" class="form-control mb-2" 
							:placeholder="$t('Type dataset ID')" />
						<div v-if="layout.deleteInput !== layout.dataset.id && layout.deleteInput.length" class="text-red-500 text-sm mb-2">
							{{ $t('The dataset ID does not match') }}
						</div>
						<div class="text-gray-600 text-xs text-center mb-2">{{ $t('This action is irreversible') }}.</div>
						<div v-if="layout.dataset.trained" class="text-xs text-center mt-2" >{{ $t('There are models associated with this dataset') }}</div>
					</div>

					<div class="rp-modal-body-buttons gap-3 mt-4 mb-3">
						<button class="rp-btn-secondary" @click="$emit('closeModal')">
							{{ $t('Cancel') }}
						</button>
						<button class="rp-btn-danger" @click="deleteDataset()"
							:disabled="layout.deleteInput !== layout.dataset.id">
							{{ $t('Delete') }}
						</button>
					</div>

				</div>

			</div>

		</div>

	</teleport>	
</template>

<script setup>
import { onMounted, ref } 	from "vue";
import { helper as $h } 	from "@/utils/helper";
import * as rosepetalModel 	from "rosepetal-model";

const $dataset = rosepetalModel.default.dataset;

const emit = defineEmits(['datasetDeleted']);

const props = defineProps({
    dataset: {
        type: Object,
        required: true,
    }
});

const layout = ref({
	dataset:		false,
	deleteInput: 	''
});

const deleteDataset = async () => { 
    await $dataset.delete(layout.value.dataset.id).then( async () => { 
        $h.NotificationTxt({ text: "Dataset successfully deleted"});
        emit('datasetDeleted');
    })
}

onMounted(() => {
	if (props.dataset) {
		layout.value.dataset = props.dataset;
	}
});
</script>